export const ProfileTranslationsCs = {
  'Nickname must be unique': 'Nickname musí být jedinečné',
  save: 'Uložit',
  lastName: 'Příjmení',
  firstName: 'Jméno',
  patronymicOptional: 'Patronymické (volitelné)',
  nickname: 'Přezdívka',
  phoneNumber: 'Telefonní číslo',
  email: 'Email',
  verifyEmail: 'Ověřit email',
  newPassword: 'Nové heslo',
  confirmNewPassword: 'Potvrďte nové heslo',
  showPassword: 'Zobrazit heslo',
  enterNewPasswordAgain: 'Zadejte nové heslo znovu',
  saveChanges: 'Uložit změny',
  profilePhoto: 'Profilová fotka',
  maxFileSize: 'Maximální velikost souboru - 5 MB',
  verify: 'Ověřit',
  verified: 'Ověřeno',

  changeEmailMessage:
    'Potvrzovací e-mail pro změnu e-mailu byl odeslán na {{email}}. Prosím, zkontrolujte svou schránku a postupujte podle pokynů pro potvrzení.',

  // errors validate
  fieldIsRequired: 'Pole je povinné',
  nameLength: 'Jméno musí být kratší než 64 znaků',
  surnameLength: 'Příjmení musí být kratší než 64 znaků',
  patronymicLength: 'Prostřední jméno musí být kratší než 64 znaků',
  latinCharacters:
    'Jsou povoleny pouze latinské písmena, číslice, pomlčky a podtržítka',
  validEmail: 'Zadejte platnou e-mailovou adresu',
  passwordMinLength: 'Heslo musí mít alespoň 8 znaků',
  passwordMaxLength: 'Heslo musí být kratší než 32 znaků',
  passwordRequirements:
    'Heslo musí obsahovat alespoň 8 latinských znaků, jedno velké písmeno a jednu číslici',
  passwordsMatch: 'Hesla se musí shodovat',

  // errors back-end
  'Email in use': 'Email je již používán.',
};
